<template>
  <v-container style="margin-top: 40px;">
      <v-menu
        v-model="menu"
        style="box-shadow: none;"
        :close-on-content-click="false"
        :close-on-click="true"
        :nudge-width="100"
        min-width="300"
        max-width="300"
        class="menu dt-border"
        offset-y
        right
      >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          outlined
          rounded
          dark
          v-bind="attrs"
          v-on="on"
        >
          <v-icon> mdi-filter-variant </v-icon>
          filter
        </v-btn>
      </template>
      <v-card class="pa-5" flat>
        <label for="">Status</label>
        <v-select
          :items="statusList"
          v-model="status"
          item-text="text"
          item-value="key"
          dense
          outlined
          return-object
        ></v-select>
        <label for="">Date</label>
        <br />
        <DateRangePicker v-model="dateRange" />
        <v-card-actions>
          <v-btn rounded depressed @click="reset">Reset</v-btn>
          <v-btn color="primary" @click="reload()" rounded depressed
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-menu>
    <chat-window
      :current-user-id="currentUserId"
      :rooms="rooms"
      :room-id="roomId"
      :messages="messages"
      :messages-loaded="messagesLoaded"
      :loading-rooms="roomsLoaded"
      :room-message="roomMessage"
      :rooms-loaded="true"
      :show-add-room="false"
      @open-file="openFile"
      @fetch-messages="fetchMessages"
      @send-message="sendMessage"
      @delete-message="deleteMessage"
      @edit-message="editMessage"
      @toggle-rooms-list="$emit('show-demo-options', $event.opened)"
      @menu-action-handler="menuActionHandler"
      :menu-actions="menuDefault"
      height="calc(100vh - 100px)"
    >
      <template #rooms-list-search>
        <div class="secondary search-field">
          <v-text-field
            placeholder="Search by Reference"
            dense
            @click:clear="clear()"
            v-model="search_ref"
            :maxlength="9"
            :readonly="searchLoader"
            :loading="searchLoader"
            clearable
            class="pa-2"
            outlined
          ></v-text-field>
        </div>
      </template>
    </chat-window>
    <div class="try"></div>
    <edittrade-modal
      @closeModal="editTrade"
      :key="editdialogProp"
      :transaction="transaction"
      :editdialogProp="editdialogProp"
    ></edittrade-modal>
    <approvetrade-modal
      @closeModal="approveTrade"
      :transaction="transaction"
      :approvedialogProp="approvedialogProp"
    ></approvetrade-modal>
    <rejecttrade-modal
      @closeModal="rejectTrade"
      :transaction="transaction"
      :rejectdialogProp="rejectdialogProp"
    ></rejecttrade-modal>
  </v-container>
</template>

<script>
// ========== IMPORT COMPONENTS ============
import ChatWindow from "vue-advanced-chat";
import "vue-advanced-chat/dist/vue-advanced-chat.css";
import EdittradeModal from "../components/edit-trade-modal.vue";
import ApprovetradeModal from "../components/approve-trade-modal.vue";
import RejecttradeModal from "../components/reject-trade-modal.vue";
import sound from "@/assets/Global/Sounds/notify.wav";
import DateRangePicker from "@/components/DateRangePicker.vue";

// ============== SERVICES ===============
import * as chatFirestoreservice from "../../../utils/firebase/firestore";
import * as storageService from "../../../utils/firebase/storage";
import { parseTimestamp } from "@/utils/dates";
import { StoresService } from "@/services";
import { saveAs } from "file-saver";

export default {
  components: {
    ChatWindow,
    EdittradeModal,
    ApprovetradeModal,
    RejecttradeModal,
    DateRangePicker
  },
  data() {
    return {
      editdialogProp: false,
      approvedialogProp: false,
      rejectdialogProp: false,
      menuDefault: [],
      menuAction: [
        {
          name: "edit",
          title: "Edit",
        },
        {
          name: "approve",
          title: "Approve",
        },
        {
          name: "decline",
          title: "Decline",
        },
      ],
      messagesLoaded: false,
      roomsLoaded: true,
      roomInterval: null,
      rooms: [],
      messagesPerPage: 20,
      searchLoader: false,
      roomsPerPage: 15,
      roomMessage: "",
      roomId: "",
      search_ref: "",
      options: {},
      transaction: {},
      listeners: [],
      storedMessage: [],
      messages: [],
      currentUserId: `${this.$store.state.userDetails.id}`,
      menu: false,
      dateRange: {
        startDate: null,
        endDate: null,
      },
      statusList: [
        {
          text: "All",
          key: null,
        },
        {
          text: "Waiting",
          key: 'waiting',
        },
        {
          text: "Processing",
          key: 'processing',
        },
        {
          text: "Approved",
          key: 'approved',
        },
        {
          text: "Declined",
          key: 'declined',
        },
      ],
      status: {
        text: "All",
        key: null,
      },
    };
  },

  // ================== FUNCTION THAT RUNS ON MOUNT =============
  mounted() {
    this.fetchRooms();
    this.roomInterval = setInterval(() => this.fetchRooms(), 60000);
    this.createAccept();
    document.getElementsByClassName("vac-box-footer")[0].style.display = "none";
    document.getElementsByClassName("accept-btn")[0].style.display = "none";
  },

  beforeDestroy() {
    clearInterval(this.roomInterval);
  },

  methods: {
    clear() {
      this.fetchRooms();
    },

    // ============= METHOD TO CREATE ACCEPT TRANSACTION ELEMENT ==============
    createAccept() {
      const newElememt = document.createElement("div");
      const btn = document.createElement("button");
      const text = document.createTextNode("Accept Trade");
      btn.appendChild(text);
      newElememt.classList.add("accept-btn");
      btn.classList.add("v-btn", "btn-target");
      btn.addEventListener("click", this.matchTrade);
      newElememt.appendChild(btn);
      const parent = document.getElementsByClassName("vac-room-footer")[0];
      parent.appendChild(newElememt);
    },

    async openFile({ file }) {
      if (file.action == "download") {
        saveAs(file.file.url, "image.jpg");
      }
    },

    // =============== METHOD TO FETCH TRANSACTIONS FROM DB ===============
    async fetchRooms(filter) {
      try {
        // this.rooms = [];
        let filters = {
            reference: filter,
            startDate: this.dateRange.startDate,
            endDate: this.dateRange.endDate,
            status: this.status.key
        };
        const data = await StoresService.loadTrades({
          page: 1,
          limit: 100,
          filters: this.cleanUpFilter(filters),
        });
        if (filter && data.total == 0) {
          this.$store.dispatch("toast", {
            message: "Invalid Reference ID",
            variant: "error",
          });
        } else {
          let datas;
          console.log(filters);
          // if (filter) {
            datas = [...data.data];
          // } else {
            // datas = [...data.ongoingTrades, ...data.data];
          // }
          let rawRooms = [];
          await datas.forEach(async (transaction) => {
            await rawRooms.push({
              roomName: transaction.reference,
              avatar: transaction.giftcard.store.logo,
              roomId: transaction.id,
              transaction: transaction,
            });
          });

          this.rooms = [...rawRooms];
          this.roomsLoaded = false;
          setTimeout(() => {
            for (let i = 0; i < datas.length; i++) {
              const statusCon =
                document.getElementsByClassName("vac-room-item")[i];
              const status = document.createElement("p");
              status.classList.add("trans-status");
              status.innerHTML = datas[i].status;
              if (datas[i].status == "declined") {
                status.classList.add("declined");
              } else if (datas[i].status == "waiting") {
                status.classList.add("waiting");
              } else if (datas[i].status == "approved") {
                status.classList.add("approved");
              } else if (datas[i].status == "processing") {
                status.classList.add("processing");
              }
              if (statusCon.getElementsByClassName("trans-status")[0]) {
                statusCon
                  .getElementsByClassName("trans-status")[0]
                  .replaceWith(status);
              } else {
                statusCon.append(status);
              }
            }
          }, 1000);
        }
      } catch (error) {
        console.log(error);
      }
    },


    async reload() {
      await this.fetchRooms();
      this.menu = false;
    },

    cleanUpFilter(obj) {
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === "") {
          delete obj[key];
        }
      });
      let check = Object.keys(obj).length === 0;
      return check ? null : obj;
    },

    async transactionStatus() {
      // ======= VERIFY TRANSACTION STATUS ======

      let transaction = this.transaction.transaction;

      // If Trade hasn't been accepted
      if (!transaction.admin) {
        document.getElementsByClassName("accept-btn")[0].style.display = "flex";
        document.getElementsByClassName("vac-box-footer")[0].style.display =
          "none";
        this.menuDefault = [];
        return;
      }

      // If trade isn't for the admin user
      if (transaction.admin.id !== this.currentUserId) {
        document.getElementsByClassName("vac-box-footer")[0].style.display =
          "none";
        document.getElementsByClassName("accept-btn")[0].style.display = "none";
        this.menuDefault = [];
        return;
      }

      // If trade is approved or declined
      if (
        transaction.status == "approved" ||
        transaction.status == "declined"
      ) {
        document.getElementsByClassName("vac-box-footer")[0].style.display =
          "none";
        document.getElementsByClassName("accept-btn")[0].style.display = "none";
        this.menuDefault = [];
        return;
      }

      if (transaction.admin.id == this.currentUserId) {
        document.getElementsByClassName("accept-btn")[0].style.display = "none";
        document.getElementsByClassName("vac-box-footer")[0].style.display =
          "flex";
        this.menuDefault = this.menuAction;
      }
    },

    // =============== METHOD TO FETCH MESSAGES BY transaction ID ================
    async fetchMessages({ room }) {
      this.roomId = room.transaction.id;
      this.transaction = await room;
      await this.transactionStatus();
      let { messages } = await chatFirestoreservice.getMessage(room.roomId);
      if (messages) {
        console.log(messages);
        setTimeout(() => (this.messagesLoaded = true), 0);
      }
      this.listenMessages(room);

      // remove unread icon if any
      const index = this.rooms.findIndex((r) => r.roomId === room.roomId);
      const chat = document.getElementsByClassName("vac-room-item")[index];
      const unread = chat.querySelector('span.unread-icon')
      if (unread) {
        unread.remove()
      }
    },

    // ============= METHOD THAT LISTENS / RUNS WHEN NEW MESSAGE COMES IN ===============
    async listenMessages(room) {
      let watching = null;
      const listener = chatFirestoreservice.listenMessages(
        room.roomId,
        (messages) => {
          if (this.roomId !== room.roomId) {
            this.notify();

            // add unread icon
            const index = this.rooms.findIndex((r) => r.roomId === room.roomId);
            const chat = document.getElementsByClassName("vac-room-item")[index];
            const unread = document.createElement("span");
            unread.classList.add("unread-icon");
            unread.innerHTML = "•";
            if (chat.getElementsByClassName("unread-icon")[0]) {
            chat
              .getElementsByClassName("unread-icon")[0]
              .replaceWith(unread);
            } else {
              chat.prepend(unread);
            }
            return
          }
          let snapShotMessage = messages.messages;
          this.storedMessage = [];
          snapShotMessage.forEach((message) => {
            const formattedMessage = this.formatMessage(message);
            this.storedMessage.push(formattedMessage);
          });
          if (watching) {
            this.notify();
          }
          watching = "on";
          this.messages = this.storedMessage;
        }
      );
      this.listeners.push(listener);
    },

    notify() {
      let notification = new Audio(sound);
      notification.play();
    },

    // =============== METHOD FOR SENDING MESSAGES ============
    async sendMessage({ content, roomId, files, replyMessage }) {
      let transaction = this.transaction.transaction;
      if (transaction.admin.id !== this.currentUserId) {
        alert("Another loader have been assigned to this chat");
        document.getElementsByClassName("vac-box-footer")[0].style.display =
          "none";
        document.getElementsByClassName("accept-btn")[0].style.display = "none";
        return;
      }
      const message = {
        senderId: this.$store.state.userDetails.id,
        content,
        dateObject: new Date(),
        _id: Date.now(),
      };

      if (files) {
        message.files = this.formattedFiles(files);
      }

      if (replyMessage) {
        message.replyMessage = {
          _id: replyMessage._id,
          content: replyMessage.content,
          sender_id: replyMessage.senderId,
        };

        if (replyMessage.files) {
          message.replyMessage.files = replyMessage.files;
        }
      }
      await chatFirestoreservice.addMessage(
        message,
        roomId,
        transaction.user.pushNotificationToken,
        transaction.giftcard.store.name
      );

      if (files) {
        for (let index = 0; index < files.length; index++) {
          await this.uploadFile({
            file: files[index],
            id: message._id,
            roomId,
          });
        }
      }
    },

    // =============== METHOD TO DELETE MESSAGE ===============
    async deleteMessage({ roomId, message }) {
      let { messages } = await chatFirestoreservice.getMessage(roomId);
      const messageIndex = messages.findIndex(
        (item) => item._id === message._id
      );
      messages.splice(messageIndex, 1);
      await chatFirestoreservice.updateMessage(messages, roomId);
    },

    // =============== METHOD TO EDIT MESSAGE ===============
    async editMessage({ roomId, messageId, newContent }) {
      let { messages } = await chatFirestoreservice.getMessage(roomId);
      const messageIndex = messages.findIndex(
        (item) => item._id === messageId
      );
      messages[messageIndex] = {
        ...messages[messageIndex],
        content: newContent,
      };
      await chatFirestoreservice.updateMessage(messages, roomId);
    },

    // ============= METHOD THAT FORMATS FILES STRUCTURE BEFORE UPLOAD =============
    formattedFiles(files) {
      const formattedFiles = [];
      files.forEach((file) => {
        const messageFile = {
          name: file.name,
          size: file.size,
          type: file.type,
          extension: file.extension || file.type,
          url: file.url || file.localUrl,
        };
        if (file.audio) {
          messageFile.audio = true;
          messageFile.duration = file.duration;
        }
        formattedFiles.push(messageFile);
      });
      return formattedFiles;
    },

    // ================ METHOD THAT UPLOADS FILES SENT DURING MESSAGE =============
    async uploadFile({ file, id, roomId }) {
      return new Promise((resolve) => {
        let type = file.extension || file.type;
        if (type === "svg" || type === "pdf") {
          type = file.type;
        }

        const path = "/giftcard/trades";
        storageService.listenUploadImageProgress(
          path,
          file,
          id,
          type,
          (progress) => {
            this.updateFileProgress(id, file.localUrl, progress);
          },
          (_error) => {
            resolve(false);
            console.log(_error);
          },
          async (url) => {
            let { messages } = await chatFirestoreservice.getMessage(roomId);

            let messageIndex = messages.findIndex(
              (message) => message._id == id
            );
            messages[messageIndex].files.forEach((f) => {
              if (f.url === file.localUrl) {
                f.url = url;
              }
            });
            await chatFirestoreservice.updateMessage(messages, roomId);
            resolve(true);
          }
        );
      });
    },

    updateFileProgress(id, fileUrl, progress) {
      const message = this.messages.find((message) => message._id === id);
      console.log(message);
      if (!message || !message.files) return;
      message.files.find((file) => file.url === fileUrl).progress = progress;
      console.log("progress", progress);
      this.messages = [...this.messages];
    },

    // ================ METHOD THAT FORMATS MESSAGES BEFORE BEEN SENT =====================
    formatMessage(message) {
      const { dateObject } = message;
      const formattedMessage = {
        ...message,
        ...{
          seconds: dateObject.seconds,
          timestamp: parseTimestamp(dateObject, "HH:mm"),
          date: parseTimestamp(dateObject, "DD MMMM YYYY"),
          distributed: true,
        },
      };
      return formattedMessage;
    },

    menuActionHandler({ action, roomId }) {
      switch (action.name) {
        case "edit":
          return this.initiateEdit(roomId);
        case "approve":
          return this.initiateApproval(roomId);
        case "decline":
          return this.initiateReject(roomId);
      }
    },

    loaderHandler(value) {
      let loading = document.getElementsByClassName("btn-target")[0];
      if (value === true) {
        loading.innerHTML = `verifying ${this.transaction.roomName} ...`;
        loading.classList.add("loading");
        loading.disabled = true;
      } else if (value === false) {
        loading.innerHTML = `Accept Trade`;
        loading.classList.remove("loading");
        loading.disabled = false;
      }
    },

    // =============== METHOD TO ACCEPT TRADE ===============
    async matchTrade() {
      try {
        this.loaderHandler(true);
        let payload = {
          trade: this.transaction.transaction.id,
          loader: this.currentUserId,
        };
        const data = await StoresService.matchTrade(payload);
        this.loaderHandler(false);
        await this.fetchRooms();
        this.transaction.transaction.admin = data.admin;
        this.transaction.transaction.status = "processing";
        let info = {
          room: this.transaction,
          options: {},
        };
        await this.fetchMessages(info);
        let message = {
          content: `Hello, welcome to Dtunes Digital. I am ${this.$store.state.userDetails.profile.firstname}. I'll be your Agent for this trade`,
          roomId: this.transaction.transaction.id,
        };
        this.sendMessage(message);

      } catch (error) {
        console.log(error);
      }
    },

    // ============== METHOD TO APPROVE TRANSACTION ===============

    initiateApproval(roomId) {
      console.log(roomId);
      this.approvedialogProp = true;
    },

    // ==== METHOD TO SEND AUTOMATED MESSAGE WHEN TRANSACTION IS APPROVE =======
    async approveTrade(roomId) {
      this.approvedialogProp = false;
      if (roomId) {
        let message = {
          content:
            "This trade has been approved, thank you for your patronage 🤝",
          roomId: roomId,
        };
        this.sendMessage(message);
        await this.fetchRooms();
        this.transaction.transaction.admin.id = this.currentUserId;
        this.transaction.transaction.status = "approved";
        let info = {
          room: this.transaction,
          options: {},
        };
        await this.fetchMessages(info);

      }
    },

    // ============== METHOD TO EDIT TRANSACTION ===============
    async initiateEdit(roomId) {
      console.log(roomId);
      this.editdialogProp = true;
    },

    // ==== METHOD TO SEND AUTOMATED MESSAGE WHEN TRANSACTION IS EDITED =======
    editTrade(data) {
      this.editdialogProp = false;
      if (data) {
        let message = {
          content:
            `This trade has been edited. The new Details are : \n\n *Giftcard : * ${data.giftcard.name}\n` +
            `*Store :* ${data.giftcard.store.name} \n` +
            `*Card Type :* ${data.giftcard.type}\n` +
            `*New Amount :* ${data.loaderAmount}\n\n` +
            `°_please confirm details above before proceeding with this trade._°`,
          roomId: data.id,
        };
        this.sendMessage(message);
        this.transaction.transaction.giftcard.name = data.giftcard.name;
        this.transaction.transaction.loaderAmount = data.loaderAmount;
      }
    },

    // ========= METHOD TO REPLACE EDITED AMOUNT INTO TRANSACTION ARRAY =======

    // ============= METHOD TO DECLINE TRANSACTION =============
    initiateReject(roomId) {
      console.log(roomId);
      this.rejectdialogProp = true;
    },

    // ==== METHOD TO SEND AUTOMATED MESSAGE WHEN TRANSACTION IS REJECTED =======
    async rejectTrade(roomId) {
      this.rejectdialogProp = false;
      if (roomId) {
        let message = {
          content: "Trade has been rejected",
          roomId: roomId,
        };
        this.sendMessage(message);
        await this.fetchRooms();
        this.transaction.transaction.admin.id = this.currentUserId;
        this.transaction.transaction.status = "declined";
        let info = {
          room: this.transaction,
          options: {},
        };
        await this.fetchMessages(info);
      }
    },
    reset() {
      this.dateRange = {
        startDate: null,
        endDate: null,
      };
      this.status = {
        text: "All",
        key: null,
      };
      this.fetchRooms();
      this.menu = false;
    },
  },
  watch: {
    async search_ref(value) {
      if (value.length == 9) {
        this.searchLoader = true;
        await this.fetchRooms(value);
        this.transaction = this.rooms[0];
        let info = {
          room: this.transaction,
          options: {},
        };
        this.searchLoader = false;
        await this.fetchMessages(info);
      }
    },
  },
};
</script>

<style lang="scss">
.accept-btn {
  display: flex;
  margin-bottom: 30px;
  justify-content: center;

  button {
    background: green;
    color: white;
    padding: 10px 20px;
    font-size: 12px;
  }
  .loading {
    background: grey !important ;
  }
}

.unread-icon {
  color: red;
  font-size: 2.5em;
}

.search-field {
  .v-text-field__details {
    display: none !important;
  }
}

.trans-status {
  font-size: 12px;
  font-weight: bold;
  &.approved {
    color: green;
  }
  &.declined {
    color: red;
  }
  &.waiting {
    color: #fcd12a;
  }
  &.processing {
    color: blue;
  }
}
</style>